import styled from "styled-components";
import { Colors } from "../util/Colors";
import errorImg from "../assets/images/error_msg.gif";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { GaizeState } from "../redux/store";
import { Roles } from "../models/enums/RolesEnum";


const MainWrapper = styled.div`
  padding:40px 0;
  margin:64px 0 0 0;
`;
export const Container = styled.div`
   width: 100%;
   padding-right: 15px;
   padding-left: 15px;
   margin-right: auto;
   margin-left: auto;
   max-width: 1140px;
`;
export const Card = styled.div`
  margin:0 0 50px 0;
  &:last-child{
    margin:0;
  }
`;
export const CardHeader = styled.div`
   display:flex;
   justify-content:space-between;
   align-items:center;
   margin:0px 0 15px 0;

   @media screen and (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
   }
`;
export const LeftWrapper = styled.div`
   display: flex;
   @media (max-width: 767px) {
      width: 100%;
   }
`;

export const CardTitle = styled.div`
   font-weight: 700;
   font-size: 21px;
   line-height: 24px;
   letter-spacing: -0.165px;
   color: #302E2E;
   margin:0 30px 0 0;
`;
export const CardSubTitle = styled.div`
   font-weight: 600;
   font-size: 15px;
   line-height: 24px;
   letter-spacing: -0.165px;
   color: #7A8EA5;
   cursor:pointer;
`;
export const CardBody = styled.div`

`;

export const MapWrapper = styled.div`
    width:100%;
    height: calc(100vh - 253px);
`;
export const MapImage = styled.img`
width:100%;
`;
export const ErrorImage = styled.img`
   max-width:100%;
   width:100%;
   height:100vh;
`;

const LinksRow = styled.div`
   display: flex;
   gap: 16px;
   flex-wrap: wrap;
`;

const NavLinkCard = styled.div`
   padding: 12px 16px;
   border: 1px solid #e5e5e5;
   border-radius: 8px;
   background: #ffffff;
   color: ${Colors.blue};
   font-weight: 600;
   cursor: pointer;
   user-select: none;

   &:hover {
      background: #f9f9f9;
   }
`;

const SuperAdmin = () => {
   const navigate = useNavigate();
   const user = useSelector((state: GaizeState) => state.user as any);
   const userData = user?.organization;
   const userRole = userData?.role;
   const pathname = window.location.pathname;
      
      return (
         <>
         {pathname === "/superAdmin" && userRole === Roles.SuperAdmin ? 
            <MainWrapper>
               <Container>
                  <Card>
                     <CardHeader>
                        <LeftWrapper>
                           <CardTitle>Super Admin</CardTitle>
                        </LeftWrapper>
                     </CardHeader>
                     <CardBody>
                        <LinksRow>
                           <NavLinkCard 
                              onClick={() => navigate("/superAdmin/customers")}>
                              Customers
                           </NavLinkCard>
                           <NavLinkCard 
                              onClick={() => navigate("/superAdmin/users")}>
                              Users
                           </NavLinkCard>
                        </LinksRow>
                     </CardBody>
                  </Card>
               </Container>
            </MainWrapper> : <ErrorImage src={errorImg} /> }
            </>
         );
};

export default SuperAdmin;
      
      